import { gsap } from 'gsap';
import BaseComponent from '../base/baseComponent';
import analytics from '@common/utils/analytics';
export default class ServiceBarComponent extends BaseComponent {
    constructor(element) {
        super(element);
        window.addEventListener('load', () => this.init());
        this.tl = gsap.timeline({ repeat: -1 });
        this.button = this.$el.querySelector('.btn-playpause');
    }
    init() {
        this.$el.classList.remove('d-none');
        this.windowWidth = window.innerWidth;
        this.list = this.$el.querySelector('.service-bar__loop');
        // this.listItemsArray = gsap.utils.toArray<HTMLElement>(this.$el.querySelectorAll('service-bar__loop--inner'));
        this.listWidth = this.list.clientWidth;
        // OE-24985, calculate timing based on list width. Base ratio is 1280px/10s, * 2 is because the inner loop will be duplicate
        this.timing = (this.list.clientWidth * 2 * 10) / 1280;
        console.log('list width', this.listWidth);
        if (this.list) {
            document.querySelectorAll('.service-bar li').forEach((item) => {
                item.addEventListener('focusin', (event) => {
                    this.$el.classList.add('isFocusing');
                    this.listenForFocus(event, item);
                });
                item.addEventListener('focusout', (event) => {
                    this.$el.classList.remove('isFocusing');
                    gsap.set(this.list, {
                        x: '0',
                        onComplete: () => this.tl.clear(),
                    });
                    if (this.isActivable && !this.isPaused) {
                        this.animate();
                    }
                });
            });
            this.$el.addEventListener('touchstart', (event) => {
                const firstTouch = event.touches[0];
                this.xDown = firstTouch.clientX;
                this.yDown = firstTouch.clientY;
            });
            const disableSelect = (e) => {
                e.preventDefault();
            };
            this.$el.addEventListener('mousedown', (event) => {
                document.body.addEventListener('mouseup', () => {
                    this.xDown = null;
                    this.yDown = null;
                    document.body.removeEventListener('selectstart', disableSelect);
                }, { once: true });
                document.body.addEventListener('selectstart', disableSelect);
                this.xDown = event.clientX;
                this.yDown = event.clientY;
            });
            this.$el.addEventListener('pointercancel', (event) => {
                if (event.pointerType != 'touch') {
                    this.xDown = null;
                    this.yDown = null;
                }
            });
            this.$el.addEventListener('touchmove', (e) => this.listenerForTouch(e));
            this.$el.addEventListener('mousemove', (e) => this.listenerForClick(e));
            // this.listInnerWidth += parseInt(gap) * this.listItemsArray.length;
            gsap.set(this.list, {
                x: '0',
            });
            this.setListWidth();
            this.listenForResize();
        }
        // let buttonPlay = document.querySelector('#btn--play') as HTMLElement;
        // let buttonPause = document.querySelector('#btn--pause') as HTMLElement;
        this.button.onclick = () => {
            this.toggleAnimation();
        };
        // buttonPause.onclick = () => {
        //   this.pauseAnimate();
        // };
        // analytics [OE-16592]
        const serviceBarLinkItem = this.$el.querySelectorAll('a[data-title-analytics]');
        serviceBarLinkItem.forEach((el) => {
            el.addEventListener('click', (e) => {
                let titleAnalytics = el.getAttribute('data-title-analytics');
                analytics.serviceBarFooter(window.datalayerdata.pageCategory, titleAnalytics, window.loggedin ? 'enter' : 'join');
            });
        });
    }
    listenerForTouch(e) {
        let xUp = e.touches[0].clientX;
        let yUp = e.touches[0].clientY;
        this.listenerForScroll(xUp, yUp);
    }
    listenerForClick(e) {
        let xUp = e.clientX;
        let yUp = e.clientY;
        this.listenerForScroll(xUp, yUp);
    }
    listenerForScroll(xUp, yUp) {
        if (!this.isPaused || !this.isActivable || !this.xDown || !this.yDown) {
            return;
        }
        let xDiff = this.xDown - xUp;
        let yDiff = this.yDown - yUp;
        // let slideWidth = this.listWidth / listLenght;
        let calculatedX = 0;
        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            const transform = getComputedStyle(this.list).transform;
            const matrix = new WebKitCSSMatrix(transform);
            calculatedX = matrix.m41 - xDiff;
            if (Math.abs(calculatedX) + this.windowWidth >= this.list.clientWidth - 50) {
                this.addClonedBar();
            }
            else if (calculatedX >= 0) {
                const clonedEl = this.addClonedBar('before');
                calculatedX = -clonedEl.clientWidth;
            }
            this.tl.clear();
            this.$el.scrollLeft = 0;
            gsap.set(this.list, {
                x: calculatedX,
                duration: 0.1,
            });
        }
        /* reset values */
        this.xDown = xUp;
        this.yDown = yUp;
    }
    listenForFocus(event, item) {
        console.log('isfocusing');
        this.tl.clear();
        if (this.isActivable) {
            this.$el.scrollLeft = 0;
            gsap.set(this.list, {
                x: -item.offsetLeft + window.innerWidth / 2 - item.offsetWidth / 2 + 'px',
            });
        }
    }
    listenForResize() {
        let timerId;
        window.addEventListener('resize', () => {
            clearTimeout(timerId);
            timerId = setTimeout(() => {
                if (this.windowWidth !== window.innerWidth) {
                    this.setListWidth();
                    this.windowWidth = window.innerWidth;
                }
            }, 500);
        });
    }
    setListWidth() {
        this.isActivable = this.listWidth > window.innerWidth;
        if (this.isActivable) {
            this.animate();
            this.$el.setAttribute('data-stacked', 'false');
            this.addClonedBar();
        }
        else {
            this.list.querySelectorAll('[data-cloned=true]').forEach((item) => {
                item.remove();
            });
            this.list.style.transform = '';
            this.stopAnimate();
            this.$el.setAttribute('data-stacked', 'true');
        }
    }
    addClonedBar(position = 'after') {
        let inner = this.list.querySelector('.service-bar__loop--inner');
        const clonedNode = inner.cloneNode(true);
        clonedNode.setAttribute('data-cloned', 'true');
        clonedNode.setAttribute('aria-hidden', 'true');
        clonedNode.setAttribute('tabindex', '-1');
        let children = clonedNode.querySelectorAll('li a');
        children.forEach((item) => {
            item.setAttribute('aria-hidden', 'true');
            item.setAttribute('tabindex', '-1');
        });
        if (position == 'after') {
            this.list.appendChild(clonedNode); // clono a dx
        }
        else {
            this.list.prepend(clonedNode); // clono a sx
        }
        return clonedNode;
    }
    animate() {
        console.log('animate');
        this.tl.to(this.list, {
            duration: this.timing,
            ease: 'none',
            x: `-=${this.listWidth}`,
            onStart: (this.isPaused = false),
        });
        if (this.tl.paused()) {
            this.tl.play();
            this.isPaused = false;
        }
        this.button.setAttribute('aria-pressed', 'false');
    }
    stopAnimate() {
        if (this.tl.progress() > 0) {
            gsap.set(this.list, {
                x: '0',
                onComplete: () => this.tl.clear(),
            });
            this.isPaused = true;
            this.button.setAttribute('aria-pressed', 'true');
        }
    }
    playAnimate() {
        if (this.tl.progress() > 0) {
            this.tl.resume();
        }
        else {
            this.animate();
        }
        this.isPaused = false;
        this.button.setAttribute('aria-pressed', 'false');
    }
    pauseAnimate() {
        this.tl.pause();
        this.isPaused = true;
        this.button.setAttribute('aria-pressed', 'true');
    }
    toggleAnimation() {
        if (this.isPaused) {
            this.playAnimate();
        }
        else {
            this.pauseAnimate();
        }
    }
}
